import { useDispatch, useSelector } from 'react-redux';
import { incrementStep, updateFormData } from '../features/FormRegistration';
import { CoverIsFor } from '../types/types';

import { pushDataLayer } from '../utils/helpers';
import MultiStepFormLayout from '../Layout/FormLayout';
import SelectableOptions from '../components/SelectableOptions';
import SimpleSingleIcon from '../icons/SimpleSingleIcon';
import SimpleCoupleIcon from '../icons/SimpleCoupleIcon';
import SimpleFamilyIcon from '../icons/SimpleFamilyIcon';
import SimpleSignleParentIcon from '../icons/SimpleSignleParentIcon';
import PrimaryButton from '../components/PrimaryButton';
function Step0() {
  const dispatch = useDispatch();
  const { isDesktopView, isMobileView } = useSelector(
    (state: any) => state.viewport,
  );
  const { formData } = useSelector((state: any) => state.formRegistration);

  const handleCoverChange = (selected: string) => {
    dispatch(
      updateFormData({
        ...formData,
        coverIsFor: selected,
      }),
    );
    pushDataLayer('funnel_cover_for', {
      cover_for: selected,
    });
  };

  const handleContinue = () => {
    pushDataLayer('funnel_state', {
      state: formData.location,
    });
    dispatch(incrementStep());
  };

  const icons = [
    <div
      className={`flex items-center justify-center ${formData.coverIsFor === CoverIsFor.Single ? 'bg-[#D1D7DF]' : 'bg-[white]'} h-[70px] w-[70px] rounded-[8px]`}>
      <SimpleSingleIcon />
    </div>,
    <div
      className={`flex items-center justify-center ${formData.coverIsFor === CoverIsFor.Couple ? 'bg-[#D1D7DF]' : 'bg-[white]'} h-[70px] w-[70px] rounded-[8px]`}>
      <SimpleCoupleIcon />
    </div>,
    <div
      className={`flex items-center justify-center ${formData.coverIsFor === CoverIsFor.Family ? 'bg-[#D1D7DF]' : 'bg-[white]'} h-[70px] w-[70px] rounded-[8px]`}>
      <SimpleFamilyIcon />
    </div>,
    <div
      className={`flex items-center justify-center ${formData.coverIsFor === CoverIsFor.SingleParentFamily ? 'bg-[#D1D7DF]' : 'bg-[white]'} h-[70px] w-[70px] rounded-[8px]`}>
      <SimpleSignleParentIcon />
    </div>,
  ];

  const options = [
    CoverIsFor.Single,
    CoverIsFor.Couple,
    CoverIsFor.Family,
    CoverIsFor.SingleParentFamily,
  ];

  if (isMobileView) {
    return (
      <MultiStepFormLayout>
        <div>
          <div className="flex flex-col items-center mb-5">
            <span className="text-[36px] font-bold text-center text-[#17385D] block">
              Compare Private Health Insurance
            </span>
            <span className="text-[18px] text-center mt-2 text-[#17385D] block">
              See prices from leading Australian
              <br />
              health funds in minutes
            </span>
            <span className="text-[18px] font-bold mt-5 self-start">
              Who is the cover for?
            </span>
          </div>

          <SelectableOptions
            options={options}
            optionClassname="w-full h-[90px]"
            value={formData.coverIsFor}
            onChange={handleCoverChange}
            icons={icons}
          />

          <div className="w-full flex flex-col items-center mt-6">
            <PrimaryButton
              text="Continue"
              onClick={handleContinue}
              classNames="w-[60%]"
              disabled={formData.coverIsFor === '-'}
            />
            <div className="flex flex-col items-center mt-4 gap-1 text-[14px]">
              <span>✅ Takes less than 2 minutes</span>
              <span>✅ 10 Years+ Experience</span>
              <span>✅ Free Service</span>
            </div>
          </div>
        </div>
      </MultiStepFormLayout>
    );
  }

  if (isDesktopView) {
    return (
      <MultiStepFormLayout>
        <div>
          <div className="flex flex-col items-center mb-5">
            <span className="text-[36px] font-bold text-center text-[#17385D] block">
              Compare Private Health Insurance
            </span>
            <span className="text-[18px] text-center mt-2 text-[#17385D] block">
              See prices from leading Australian
              <br />
              health funds in minutes
            </span>
            <span className="text-[18px] font-bold mt-5 self-start">
              Who is the cover for?
            </span>
          </div>

          <div className="flex w-full">
            <SelectableOptions
              options={options}
              optionClassname="w-[calc(50%-5px)] h-[90px]"
              value={formData.coverIsFor}
              onChange={handleCoverChange}
              icons={icons}
            />
          </div>

          <div className="w-full flex flex-col items-center mt-6">
            <PrimaryButton
              text="Continue"
              onClick={handleContinue}
              classNames="w-[250px]"
              disabled={formData.coverIsFor === '-'}
            />
            <div className="flex flex-col items-center mt-4 gap-1 text-[14px]">
              <span>✅ Takes less than 2 minutes</span>
              <span>✅ 10 Years+ Experience</span>
              <span>✅ Free Service</span>
            </div>
          </div>
        </div>
      </MultiStepFormLayout>
    );
  }
}

export default Step0;
